import React, { useState }  from 'react';
import ShowChibi from './ShowChibi';
import {AiOutlineSound} from "react-icons/ai";





function ClickMeAnimation(props) {

  const [showChibiAnimation, setChibiAnimation] = useState(false); 

  const img = new Image();
  img.onload = () => {
    // when it finishes loading, update the component state
  //  console.log("Image is ready!");
  }
  img.src = props.img; 

let charSound = new Audio(props.sound);
charSound.volume = 0.25; 
//console.log(props.head);
//console.log(props.img);

    return (
    <div>
      <button
        aria-label="Click for a surprise!"
        onClick={() => {
            charSound.play();
            setChibiAnimation(true);
            setTimeout(() => {
                setChibiAnimation(false);
            }, 4000);
        }}
        className="customButton float-end"
        style={{backgroundImage: `url(${props.head})`}}>
          <div className="cornerTriangle"><div className="soundIcon"><AiOutlineSound fill='white'/></div></div>
      </button>
      <div className='popupChibi'>
      {showChibiAnimation && <ShowChibi src={props.img}/>}
      </div>
    </div>
    )
  }

export default ClickMeAnimation;
